import { ServiceOfferingBlock } from '@sapientpro/sapientpro-data-models';
import { useRef, useState } from 'react';
import styles from './ServicesSection.module.scss';
import Img from '../Img';
import Video from '../Video/Video';

interface IMediaCardProps {
  data: ServiceOfferingBlock
}

const MediaCard = ({ data }: IMediaCardProps) => {
  const [activeImageIndex, setActiveImageIndex] = useState<number>(0);
  const currentImageIndexRef = useRef<number>(0);
  const intervalIdRef = useRef<NodeJS.Timer | null>(null);
  const wrapperRef = useRef<HTMLDivElement>(null);

  const handleImagesAnimation = () => {
    if (data.media.length) {
      const currentIndex = currentImageIndexRef.current;
      const newIndex = currentIndex + 1;
      const maxIndex = (data?.media?.length as number) - 1;
      const isToReset = newIndex > maxIndex;

      const nextIndex = isToReset ? 0 : newIndex;

      setActiveImageIndex(nextIndex);
      currentImageIndexRef.current = nextIndex;
    }
  };

  const runImagesAnimation = () => {
    if (data.media?.length) {
      setActiveImageIndex(1);
      currentImageIndexRef.current = 1;
      const intervalId = setInterval(handleImagesAnimation, 1000);
      intervalIdRef.current = intervalId;
    }
  };

  const stopImagesAnimation = () => {
    if (intervalIdRef.current) {
      clearInterval(intervalIdRef.current);
      setActiveImageIndex(0);
      currentImageIndexRef.current = 0;
    }
  };

  const isImage = !['mp4, webm'].includes(data?.media[activeImageIndex].ext);

  const handleStopAnimation = () => {
    if (isImage) {
      stopImagesAnimation();
    } else if (data.media) {
      const videoBlock = wrapperRef.current?.getElementsByTagName('video')?.[0];
      if (videoBlock) videoBlock.pause();
    }
  };

  const handleStartAnimation = () => {
    if (isImage) {
      runImagesAnimation();
    } else if (data.media) {
      const videoBlock = wrapperRef.current?.getElementsByTagName('video')?.[0];
      if (videoBlock) videoBlock.play();
    }
  };

  const currentImage = data?.media?.[activeImageIndex];

  return (
    <div
      className={styles.mediaCard}
      onMouseEnter={handleStartAnimation}
      onMouseLeave={handleStopAnimation}
      ref={wrapperRef}
    >
      {isImage && !!currentImage ? (
        <Img
          src={currentImage.url}
          alt={currentImage.alternativeText || 'media card image'}
          className={styles.mediaCardImage}
        />
      ) : (
        <Video
          video={{
            clip: {
              id: currentImage.id,
              url: currentImage.url,
              ext: currentImage.ext,
              alternativeText: currentImage.alternativeText,
              caption: currentImage.caption,
            },
            loop: true,
          }}
          activeIndex={1}
          view='default'
          videoType='custom'
          videoClassName={styles.mediaCardVideo}
        />
      )}
    </div>
  );
};

export default MediaCard;
